module.exports = __webpack_public_path__ + "img/erin-patterson10.0699d64c.png";